import {defer, EMPTY, Observable, Subject, switchMap} from 'rxjs';

import {inject, Injectable} from '@angular/core';
import {CompanySettingsStore} from '@company-settings/data-access';
import {BackendService, IFaceMatchRequest, IFaceMatchResponse} from '@core/api/data-access';
import {StoredFile} from '@global-data';
import {mergeBase64Images} from '@utils/base64';

@Injectable({
	providedIn: 'root',
})
export class FaceMatchService extends BackendService {
	private readonly companySettingsStore: CompanySettingsStore = inject(CompanySettingsStore);
	/* -------------------------------------------------------------------------------------------------------------- */
	public results$: Subject<StoredFile> = new Subject<StoredFile>();

	constructor() {
		super('ValidationRules');
	}

	public matchFaces(images: string[], mergeMatchResults = false): Observable<StoredFile> {
		const predictorTrust = this.companySettingsStore.state()?.settings?.predictorTrust || 0.7;
		return this.apiService.post<IFaceMatchResponse, IFaceMatchRequest>(this.getUrl('facematch'), {images}).pipe(
			switchMap((response: IFaceMatchResponse) => {
				const isMatch: boolean = response.similarity * 100 >= predictorTrust;
				if (isMatch && mergeMatchResults) {
					return defer(async () => {
						const mergedImage = await mergeBase64Images(images?.at(0), images?.at(1));
						return new StoredFile(mergedImage, 'image/png');
					});
				}
				return EMPTY;
			}),
		);
	}
}
